import { apiKeyClient } from "@better-auth/api-key/client";
import {
	convexClient,
	crossDomainClient,
} from "@convex-dev/better-auth/client/plugins";
import {
	oneTimeTokenClient,
	organizationClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

const CONVEX_SITE_URL = (
	import.meta.env.VITE_CONVEX_SITE_URL ||
	(typeof window !== "undefined"
		? `${window.location.protocol}//${window.location.host}`
		: "")
).trim();

export const authClient = createAuthClient({
	baseURL: CONVEX_SITE_URL,
	plugins: [
		convexClient(),
		crossDomainClient(),
		oneTimeTokenClient(),
		organizationClient(),
		apiKeyClient(),
	],
});

export const AUTH_ENABLED = CONVEX_SITE_URL.length > 0 && !import.meta.env.SSR;

export const LOGIN_PATH = "/login";
export const SETUP_PATH = "/setup";
export const WORKSPACE_PATH = "/workspace";

/** Extract `activeOrganizationId` from a Better Auth session (added by the organization plugin). */
export function getActiveOrgId(session: unknown): string | null {
	if (
		typeof session === "object" &&
		session !== null &&
		"activeOrganizationId" in session &&
		typeof session.activeOrganizationId === "string"
	) {
		return session.activeOrganizationId;
	}
	return null;
}

type OrganizationLike = {
	id: string;
	slug?: string | null;
};

export function resolveTenantId(
	organization: OrganizationLike | null | undefined,
): string | null {
	if (!organization) return null;
	const slug = organization.slug?.trim();
	return slug || organization.id;
}
